const color = require("color");

let ratio = 0.618033988749895;
let hue = Math.random();

export default function getColor(saturation, value) {
  hue += ratio;
  hue %= 1;

  if (typeof saturation !== "number") {
    saturation = 0.9;
  }

  if (typeof value !== "number") {
    value = 0.95;
  }

  return color({
    h: hue * 360,
    s: saturation * 100,
    v: value * 100
  });
}
